import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=720f5cee&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=720f5cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f5cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720f5cee')) {
      api.createRecord('720f5cee', component.options)
    } else {
      api.reload('720f5cee', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=720f5cee&scoped=true&", function () {
      api.rerender('720f5cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4bHD2y2JfW43P/JS/comp/CookieBox.vue"
export default component.exports